import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { createPortal } from 'react-dom';
import { styled } from '@mui/material/styles';

const SpinnerContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    textAlign: 'center'
});

interface LoadingOverlayProps {
    open: boolean;
    message?: string;
    size?: number;
    showMessage?: boolean;
    color?: string;
}

export const LoadingOverlay = ({
    open,
    message = 'Processing...',
    size = 88,
    showMessage = false,
    color = '#0099cc'
}: LoadingOverlayProps) => {
    if (!open) return null;

    const overlay = (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 99999,
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <SpinnerContainer>
                <CircularProgress
                    size={size}
                    thickness={5}
                    sx={{
                        color: color,
                        '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round',
                            stroke: color
                        }
                    }}
                />
                {showMessage && message && (
                    <Typography variant="h6" sx={{ color: color, fontWeight: 300 }}>
                        {message}
                    </Typography>
                )}
            </SpinnerContainer>
        </Box>
    );

    return createPortal(overlay, document.body);
};
